import { render, staticRenderFns } from "./Varinhas.vue?vue&type=template&id=470b50ae&scoped=true"
import script from "./Varinhas.vue?vue&type=script&lang=js"
export * from "./Varinhas.vue?vue&type=script&lang=js"
import style0 from "./Varinhas.vue?vue&type=style&index=0&id=470b50ae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "470b50ae",
  null
  
)

export default component.exports